import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pnk-tab',
  shadow: false,
})
export class PnkTab {
  @Prop() label: string = '';

  @Prop() active: boolean = false;

  @Prop({ reflect: true }) disabled: boolean = false;

  render() {
    return (
      <Host style={{ display: this.active ? 'block' : 'none' }} class="pnk-w-full pnk-h-full pnk-bg-white">
        <slot></slot>
      </Host>
    );
  }
}
